export type IResetUserPassword = (button: IjQueryElmOrHtmlElm) => void;

export function resetUserPassword(button: IjQueryElmOrHtmlElm): void {
  const $button = $(button);
  const postUrl = $button.data('href');
  const jsonEncoded = $button.data('json');
  const json = JSON.parse(decodeURIComponent(jsonEncoded));
  const { successMessage, successTitle, errorMessage, errorTitle } = json;

  $.post(postUrl).done((postResponseData: IDCA.IPostResponse) => {
    if (postResponseData.success === 'true') {
      window.DexeroCoreApp.userToastMsg('success', successTitle, successMessage);
    } else {
      window.DexeroCoreApp.userToastMsg('error', errorTitle, errorMessage);
    }
  });
}
